import React, { useState, useEffect, useRef, useContext } from "react";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import Grid from "@mui/material/Grid";
import Autocomplete from "@mui/material/Autocomplete";
import Button from "@mui/material/Button";
import { useNavigate } from "react-router-dom";
import DashboardLayout from "../../../../../../examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "../../../../../../examples/Navbars/DashboardNavbar";
import CrudService from "services/cruds-service";
import "jspdf-autotable";
import Footer from "../../../../../../examples/Footer";
import { FormControlLabel } from "@mui/material";
// Büyük formda her tuşta tüm formun yeniden çizilmesini önleyen tamponlu TextField (yazma gecikmesi)
import TextField from "components/BufferedTextField";
import Switch from "@mui/material/Switch";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { isValid } from "date-fns";
import { tr } from "date-fns/locale";
import { useLocation } from "react-router-dom";
import { AuthContext } from "../../../../../../context/index";
import { Dialog, DialogTitle, DialogContent, DialogActions } from "@mui/material";
import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import countryOptions from "../../components/List/Countries";
import {t} from "../../../../../../langs";
import { appAlert } from "components/AppDialog";
import { AddRowButton, RemoveRowButton } from "components/RowActions";
import { CrmPageHeader, CrmNotice, CrmActionButton, crmCardSx } from "../shared/CrmUi";
import { ReadOnlyBanner, ReadOnlyFieldset } from "components/ReadOnlyLock";

const CreateMeeting = (meeting) => {
    const navigate = useNavigate();
    const { user } = useContext(AuthContext);

    const [selectedCustomer, setSelectedCustomer] = useState(null);
    const [customerOptions, setCustomerOptions] = useState([]); // Options for Autocomplete
    const [customerCountry, setCustomerCountry] = useState(null);
    const [city, setCity] = useState(null);
    const [taxId, setTaxId] = useState(null);
    const [representatives, setRepresentatives] = useState(""); // string fix
    const [representativesTitle, setRepresentativesTitle] = useState(null);
    const [representativesContact, setRepresentativesContact] = useState(null);
    const [webSite, setWebSite] = useState(null);
    const [industry, setIndustry] = useState(""); // string fix
    const [companySize, setCompanySize] = useState(null);
    const [logisticsDecision, setLogisticsDecision] = useState(null);
    const [salesRep, setSalesRep] = useState([]);
    const [attendees, setAttendees] = useState([]);

    const [preMeetingTitle, setPreMeetingTitle] = useState("");
    const [preMeetingNotes, setPreMeetingNotes] = useState("");
    const [meetingTitle, setMeetingTitle] = useState("");
    const [meetingDate, setMeetingDate] = useState(null);
    const [meetingTime, setMeetingTime] = useState("");
    const [meetingDuration, setMeetingDuration] = useState("");
    const [meetingType, setMeetingType] = useState("");
    const [meetingStatus, setMeetingStatus] = useState("Planned");
    const [participants, setParticipants] = useState([""]); // başlangıç bir boş öğe
    const [meetingPlatform, setMeetingPlatform] = useState("");
    const [meetingNotes, setMeetingNotes] = useState("");
    const [wasCompleted, setWasCompleted] = useState(false);
    const [recapMeetingNotes, setRecapMeetingNotes] = useState("");
    const [recapCompleted, setRecapCompleted] = useState(false);

    const [customerEmails, setCustomerEmails] = useState({});
    const [selectedCustomerEmail, setSelectedCustomerEmail] = useState("customer@example.com");

    const location = useLocation();

    const [loading, setLoading] = useState(false);
    const [isEditing, setIsEditing] = useState(false);
    const searchParams = new URLSearchParams(location.search);
    const meetingId = searchParams.get("id");
    // An existing meeting opens read-only, like the TMS pages; "Edit" unlocks the form.
    const [readOnlyMode, setReadOnlyMode] = useState(Boolean(meetingId));

    const [successMessage, setSuccessMessage] = useState("");
    const successMessageRef = useRef(null);

    const [dateError, setDateError] = useState("");
    const [timeError, setTimeError] = useState("");

    const companySizeOptions = ["Small", "Mid Size", "Large", "Extra Large", "Global"];
    const logisticsOptions = ["Export", "Import", "All"];
    const meetingDurations = ["15 min", "30 min", "1 hour", "2 hours"];
    const meetingTypes = ["New Business", "First Touch - Cold Call", "Building Relationship", "Business Development", "Retention"];
    const meetingPlatforms = ["Zoom", "Google Meet", "Microsoft Teams", "WhatsApp", "By Phone Call", "Face to Face"];

    const [customerList, setCustomerList] = useState([]);
    const [globalAgentList, setGlobalAgentList] = useState([]);
    const [serviceProviderList, setServiceProviderList] = useState([]);
    const [partyType, setPartyType] = useState("Customer"); // 'Customer' | 'GlobalAgent'

    const { leadCompany, leadId } = location.state || {};
    const [cityOptions, setCityOptions] = useState([]);
    const [cityLoading, setCityLoading] = useState(false);

    const [salesRepOptions, setSalesRepOptions] = useState([]);
    const [emailPreviewOpen, setEmailPreviewOpen] = useState(false);
    const [emailPreviewData, setEmailPreviewData] = useState({
        to: "",
        cc: "",
        subject: "",
        body: ""
    });

    useEffect(() => {
        const fetchSalesReps = async () => {
            try {
                const response = await CrudService.getUsers();
                const users = response.data;

                const formattedUsers = users.map((user) => ({
                    id: user.id,
                    label: user.attributes.name,
                    email: user.attributes.email || ""
                }));

                setSalesRepOptions(formattedUsers);
            } catch (error) {
                console.error("Satış temsilcileri alınamadı:", error);
            }
        };

        fetchSalesReps();
    }, []);

    // Edit modu
    useEffect(() => {
        if (meetingId) {
            setIsEditing(true);
        }
        setReadOnlyMode(Boolean(meetingId));
    }, [meetingId]);

    // Customer & GA fetch
    useEffect(() => {
        const fetchParties = async () => {
            try {
                const [customerResponse, globalAgentResponse, spResponse] = await Promise.all([
                    CrudService.getCustomers(),
                    CrudService.getGlobalAgents(),
                    CrudService.getServiceProviders(), // ✅ yeni
                ]);

                const customers = customerResponse.data.map((c) => ({
                    name: c.attributes?.name || "Unnamed Customer",
                    id: c.id,
                    email: c.attributes?.email || "customer@example.com",
                    type: "Customer",
                }));

                const globalAgents = globalAgentResponse.data.map((a) => ({
                    name: a.attributes?.name || "Unnamed Global Agent",
                    id: a.id,
                    email: a.attributes?.email || "globalAgent@example.com",
                    type: "GlobalAgent",
                }));

                const serviceProviders = spResponse.data.map((sp) => ({
                    name: sp.attributes?.name || "Unnamed Service Provider",
                    id: sp.id,
                    email: sp.attributes?.email || "serviceProvider@example.com",
                    type: "ServiceProvider",
                }));

                setCustomerList(customers);
                setGlobalAgentList(globalAgents);
                setServiceProviderList(serviceProviders);

                // ✅ partyType'a göre opsiyonları set et
                const map = {
                    Customer: customers,
                    GlobalAgent: globalAgents,
                    ServiceProvider: serviceProviders,
                };
                setCustomerOptions(map[partyType] || customers);

                // ✅ email map (3 liste)
                const emails = {};
                [...customers, ...globalAgents, ...serviceProviders].forEach((x) => {
                    emails[x.name] = x.email;
                });
                setCustomerEmails(emails);
            } catch (error) {
                console.error("Party verileri alınırken hata:", error);
            }
        };

        fetchParties();
    }, []);

    useEffect(() => {
        const map = {
            Customer: customerList,
            GlobalAgent: globalAgentList,
            ServiceProvider: serviceProviderList,
        };

        const opts = map[partyType] || [];
        setCustomerOptions(opts);

        if (selectedCustomer && selectedCustomer.type !== partyType) {
            setSelectedCustomer(null);
        }

        setInputValue("");
        setOpen(false);
    }, [partyType, customerList, globalAgentList, serviceProviderList]);


    useEffect(() => {
        if (!leadCompany) return;

        const lc = leadCompany.trim().toLowerCase();
        if (
            customerList.length === 0 &&
            globalAgentList.length === 0 &&
            serviceProviderList.length === 0
        ) return;

        const all = [...customerList, ...globalAgentList, ...serviceProviderList];
        const found = all.find((x) => x.name?.trim().toLowerCase() === lc);

        if (found) {
            setPartyType(found.type);
            setSelectedCustomer(found);
        }
    }, [leadCompany, customerList, globalAgentList, serviceProviderList]);


    function useQuery() {
        return new URLSearchParams(useLocation().search);
    }

    const query = useQuery();
    const selectedDate = query.get("date"); // "2025-06-15" gibi

    useEffect(() => {
        if (selectedDate && !meetingId) {
            setMeetingDate(new Date(selectedDate));
        }
    }, [selectedDate, meetingId]);

    const parseDate = (dateString) => {
        if (!dateString) return new Date();
        try {
            const parsedDate = new Date(dateString);
            return isValid(parsedDate) ? parsedDate : new Date();
        } catch (error) {
            return new Date();
        }
    };

    const fetchMeetingDetails = async (id) => {
        // listeler hazır değilse geri dön
        if (customerList.length === 0 && globalAgentList.length === 0) return;

        setLoading(true);
        try {
            const response = await CrudService.getMeetingById(id);
            const meetingData = response.data.attributes;

            // Tür çıkarımı: isim hangi listede?
            const nameLc = (meetingData.customer || "").trim().toLowerCase();

            const cMatch  = customerList.find((o) => o.name?.trim().toLowerCase() === nameLc);
            const gaMatch = globalAgentList.find((o) => o.name?.trim().toLowerCase() === nameLc);
            const spMatch = serviceProviderList.find((o) => o.name?.trim().toLowerCase() === nameLc);
            const inferredType = cMatch ? "Customer" : gaMatch ? "GlobalAgent" : spMatch ? "ServiceProvider" : partyType;
            if (inferredType !== partyType) setPartyType(inferredType);
            const candidates =
                inferredType === "Customer"
                    ? customerList
                    : inferredType === "GlobalAgent"
                        ? globalAgentList
                        : serviceProviderList;
            const matchedCustomer = candidates.find(
                (opt) => opt.name?.trim().toLowerCase() === meetingData.customer?.trim().toLowerCase()
            );

            setSalesRep(
                Array.isArray(meetingData.salesRep)
                    ? salesRepOptions.filter((repOption) => meetingData.salesRep.includes(repOption.id))
                    : []
            );
            setAttendees(
                Array.isArray(meetingData.attendees)
                    ? salesRepOptions.filter((repOption) => meetingData.attendees.includes(repOption.id))
                    : []
            );

            setSelectedCustomer(matchedCustomer || null);
            setTaxId(meetingData.taxId || "");
            setCustomerCountry(meetingData.customerCountry || "");
            setCity(meetingData.city || "");
            setRepresentatives(meetingData.representatives || "");
            setRepresentativesTitle(meetingData.representativesTitle || "");
            setRepresentativesContact(meetingData.representativesContact || "");
            setWebSite(meetingData.webSite || "");
            setIndustry(Array.isArray(meetingData?.customerIndustry) ? meetingData?.customerIndustry?.join(", ") : (meetingData.industry || ""));
            setCompanySize(meetingData.companySize || "");
            setLogisticsDecision(meetingData.logisticsDecision || "");
            setPreMeetingTitle(meetingData.preMeetingTitle || "");
            setPreMeetingNotes(meetingData.preMeetingNotes || "");
            setMeetingTitle(meetingData.meetingTitle || "");
            setMeetingDate(parseDate(meetingData.meetingDate));
            setMeetingTime(meetingData.meetingTime);
            setMeetingDuration(meetingData.meetingDuration || "");
            setMeetingType(meetingData.meetingType || "");
            setMeetingStatus(meetingData.meetingStatus || "");
            setParticipants(Array.isArray(meetingData.participants) ? meetingData.participants : [""]);
            setMeetingPlatform(meetingData.meetingPlatform || "");
            setMeetingNotes(meetingData.meetingNotes || "");
            setRecapMeetingNotes(meetingData.recapMeetingNotes || "");
            setRecapCompleted(meetingData.recapCompleted === true || meetingData.recapCompleted === "true");

            if (meetingData.meetingStatus === "Completed") {
                setWasCompleted(true);
            }
            if (meetingData.meetingStatus === "Completed") {
                setWasCompleted(true);
            }

            setMeetingNotes(meetingData.meetingNotes || "");
        } catch (error) {
            console.error("Error fetching meeting details:", error);
        } finally {
            setLoading(false);
        }
    };

    // Meeting detaylarını listeler hazır olduğunda getir
    useEffect(() => {
        if (meetingId && (customerList.length > 0 || globalAgentList.length > 0)) {
            fetchMeetingDetails(meetingId);
        }
    }, [meetingId, customerList, globalAgentList, partyType]); // eslint-disable-line

    const [inputValue, setInputValue] = useState(""); // Kullanıcı girişini takip etmek için
    const [open, setOpen] = useState(false); // Listeyi kontrol etmek için


    useEffect(() => {
        const fetchCities = async () => {
            const country = (customerCountry || "").trim();
            if (!country) {
                setCityOptions([]);
                setCity("");
                return;
            }

            setCityLoading(true);
            try {
                const res = await CrudService.getCitiesByCountry(country);

                // res format normalize: {data:{data:[...]}} veya {data:[...]}
                const raw = res?.data?.data ?? res?.data ?? [];
                const normalized = raw
                    .map((x) => (typeof x === "string" ? x : x?.name || x?.label))
                    .filter(Boolean);

                setCityOptions(normalized);

                // seçili city listede yoksa temizle (opsiyonel)
                if (city && !normalized.includes(city)) {
                    // burada city'yi silmek istemezsen bu bloğu kaldır
                    // setCity("");
                }
            } catch (e) {
                console.error("City list fetch error:", e);
                setCityOptions([]);
            } finally {
                setCityLoading(false);
            }
        };

        // edit modda country/city alanları disabled ama yine de listeleri doldurmak istersen kalsın
        fetchCities();
    }, [customerCountry]); // eslint-disable-line

    const handleCustomerChange = async (event, newValue) => {
        setSelectedCustomer(newValue);

        if (newValue && newValue.id) {
            try {
                const fetchFn =
                    newValue.type === "GlobalAgent"
                        ? CrudService.getGlobalAgentById
                        : newValue.type === "ServiceProvider"
                            ? CrudService.getServiceProviderById
                            : CrudService.getCustomerById;

                const response = await fetchFn(newValue.id);
                const attributes = response.data.attributes || {};

                const fetchedSalesReps = attributes.salesRep || [];

                const waitForSalesReps = () => {
                    if (salesRepOptions.length === 0) {
                        setTimeout(waitForSalesReps, 100);
                    } else {
                        const idArray = fetchedSalesReps.map((rep) => rep._id);
                        const matchedSalesReps = salesRepOptions.filter((repOption) => idArray.includes(repOption.id));
                        setSalesRep(matchedSalesReps);
                    }
                };
                waitForSalesReps();

                setTaxId(attributes?.taxID || "");
                setCity(attributes?.city || "");
                setCustomerCountry(attributes?.customerCountry || "");
                setRepresentatives(attributes?.representatives?.map((rep) => rep.name).join(", ") || "");
                setRepresentativesTitle(attributes?.representatives?.map((rep) => rep.title).join(", ") || "");
                setRepresentativesContact(attributes?.representatives?.map((rep) => rep.contactInfo).join(", ") || "");
                setWebSite(attributes?.website || "");
                setIndustry(attributes?.customerIndustry || "");
                setParticipants(attributes?.representatives?.map((rep) => rep.name) || [""]);
            } catch (error) {
                console.error(`${newValue.type} detayları çekilirken hata oluştu:`, error);
            }
        } else {
            // Alanları temizle
            setTaxId("");
            setCustomerCountry("");
            setCity("");
            setRepresentatives("");
            setRepresentativesTitle("");
            setRepresentativesContact("");
            setWebSite("");
            setIndustry("");
            setParticipants([""]);
            setSalesRep([]);
        }
    };

    const submitHandler = async (e) => {
        e.preventDefault();

        let hasError = false;
        if (!meetingDate) {
            setDateError("Meeting Date is required");
            hasError = true;
        }
        if (!meetingTime) {
            setTimeError("Time is required");
            hasError = true;
        }
        if (hasError) {
            return;
        }

        // Completed ise min 25 char
        if (meetingStatus === "Completed" && meetingNotes.length < 25) {
            appAlert("⚠️ Meeting Notes must be at least 25 characters to submit!");
            return;
        }

        const meetingData = {
            customer: selectedCustomer ? String(selectedCustomer.name) : "Unknown Customer",
            taxId,
            customerCountry,
            city,
            salesRep: salesRep.map((rep) => rep.id),
            representatives,
            representativesTitle,
            representativesContact,
            webSite,
            industry,
            companySize,
            logisticsDecision,
            preMeetingTitle,
            preMeetingNotes,
            meetingTitle,
            meetingDate,
            meetingTime,
            meetingDuration,
            meetingType,
            meetingStatus,
            participants,
            meetingPlatform,
            meetingNotes,
            recapMeetingNotes,
            recapCompleted,
            attendees: attendees.map((att) => att.id)
        };

        try {
            setLoading(true);

            let response;
            if (isEditing) {
                response = await CrudService.updateMeeting(meetingData, meetingId);
                setSuccessMessage("Update meeting was successfully completed.");
            } else {
                response = await CrudService.createMeeting({
                    data: meetingData
                });
                setSuccessMessage("Create meeting was successfully completed.");
            }
            window.scrollTo({ top: 0, behavior: "smooth" });
            setTimeout(() => {
                navigate("/meeting/meeting-tables/details");
            }, 3000);
        } catch (err) {
            console.error("Request failed: ", err);
        } finally {
            setLoading(false);
        }
    };

    // Katılımcı ekle/kaldır
    const handleAddParticipant = () => {
        setParticipants((prevParticipants) => [...prevParticipants, ""]);
    };

    const handleRemoveParticipant = (index) => {
        setParticipants((prevParticipants) => prevParticipants.filter((_, i) => i !== index));
    };

    const handleParticipantChange = (index, value) => {
        setParticipants((prevParticipants) => {
            const updatedParticipants = [...prevParticipants];
            updatedParticipants[index] = value;
            return updatedParticipants;
        });
    };

    const validateMeetingStatus = (newStatus) => {
        const now = new Date();
        const selectedDateTime = meetingDate ? new Date(meetingDate) : now;

        if (meetingTime) {
            let timeString;

            if (typeof meetingTime === "string") {
                timeString = meetingTime;
            } else if (meetingTime instanceof Date) {
                const hours = meetingTime.getHours().toString().padStart(2, "0");
                const minutes = meetingTime.getMinutes().toString().padStart(2, "0");
                timeString = `${hours}:${minutes}`;
            } else {
                timeString = "00:00";
            }

            const timeParts = timeString.split(":");
            selectedDateTime.setHours(parseInt(timeParts[0], 10));
            selectedDateTime.setMinutes(parseInt(timeParts[1], 10));
        }

        if (selectedDateTime > now) {
            return "Planned";
        }

        if (wasCompleted && newStatus !== "Completed") {
            return "Completed";
        }
        return newStatus;
    };

    const handleRecapSwitch = (event) => {
        setRecapCompleted(event.target.checked === true);
    };

    // seçilen müşterinin email'i
    useEffect(() => {
        if (!selectedCustomer) return;
        const email = customerEmails[selectedCustomer?.name] || "customer@example.com";
        setSelectedCustomerEmail(email);
    }, [selectedCustomer, customerEmails]);

    const plainTextVersion = (html) => {
        return html.replace(/<[^>]*>/g, "").replace(/\s+/g, " ").trim();
    };

    const prepareEmailData = () => {
        const customerName = selectedCustomer?.name || "Dear Customer";
        const singleDate = Array.isArray(meetingDate) ? meetingDate[0] : meetingDate;
        const formattedDate = singleDate
            ? new Date(singleDate).toLocaleDateString("tr-TR", {
                weekday: "long",
                year: "numeric",
                month: "long",
                day: "numeric"
            })
            : "Unknown";
        const formattedTime = meetingTime || "Unknown";
        const email = customerEmails[selectedCustomer?.name] || "customer@example.com";

        const loggedInUserEmail = user?.email || "default@example.com";
        const attendeesEmails = attendees.map((att) => att.email).filter(Boolean);
        const ccList = [loggedInUserEmail, ...attendeesEmails].filter(
            (v, i, self) => v && self.indexOf(v) === i
        );

        let extraMessage = "";
        if (["New Business", "First Touch - Cold Call"].includes(meetingType)) {
            extraMessage = `
        <hr style="border:1px solid #ddd; margin: 32px 0;" />
        <h3 style="color:#0073e6;">🌟 Who We Are</h3>
        <p>
            <strong>Filenders Logistics and Technology Inc.</strong> is a next-generation logistics startup, born from strategic partnerships with Turkey’s leading logistics companies. Headquartered in Mersin Technopark, we combine deep industry knowledge with innovative technologies to deliver transparent, optimized, and scalable logistics solutions.
        </p>
        <p style="font-style: italic;">Our motto: <strong>“Discover the True Path”</strong></p>
        <h3 style="color:#0073e6;">🏢 Our Offices</h3>
        <ul>
            <li><strong>Turkey:</strong> Mersin, Istanbul</li>
            <li><strong>Middle East:</strong> Erbil, Iraq</li>
            <li><strong>Europe:</strong> Cologne, Germany</li>
        </ul>
        <h3 style="color:#0073e6;">📦 Our Core Services</h3>
        <ul>
            <li>Road Transportation</li>
            <li>Ocean Freight</li>
            <li>Air Freight</li>
            <li>Project Cargo</li>
        </ul>
        <h3 style="color:#0073e6;">💡 Why Choose Filenders?</h3>
        <ul>
            <li><strong>Fast & On-Time Delivery:</strong> Real-time shipment visibility with advanced infrastructure</li>
            <li><strong>Reliability:</strong> Operated by a team of experienced professionals</li>
            <li><strong>Sustainability:</strong> Minimize environmental impact through eco-conscious transport</li>
        </ul>
        <h3 style="color:#0073e6;">🛠 Our Technologies</h3>
        <ul>
            <li>Route Optimization</li>
            <li>Transportation Management System (TMS)</li>
            <li>End-to-End Supply Chain Traceability</li>
        </ul>
      `;
        }

        const htmlBody = `
      <div style="font-family:'Segoe UI', sans-serif; font-size:15px; line-height:1.6; color:#333;">
        <p>Dear ${customerName},</p>
        <p>Below is a summary of our meeting:</p>

        <ul>
            <li><strong>📅 Meeting Date:</strong> ${formattedDate}</li>
            <li><strong>⏰ Time:</strong> ${formattedTime}</li>
            <li><strong>📝 Notes:</strong><br>
            ${recapMeetingNotes}</li>
        </ul>

        ${extraMessage}

        <p style="margin-top:32px;">
            Best Regards,<br/>
            <strong>CRM Filenders Tech & Innovation Team</strong>
        </p>
      </div>
    `;

        return {
            to: email,
            cc: ccList.join(","),
            subject: `${meetingTitle || "Untitled"}`,
            body: htmlBody,
            text: plainTextVersion(htmlBody)
        };
    };

    const handleSendPreview = () => {
        if (!recapMeetingNotes.trim()) {
            appAlert("⚠️ Please enter recap meeting notes before sending the email.");
            return;
        }
        const draft = prepareEmailData();
        setEmailPreviewData(draft);
        setEmailPreviewOpen(true);
    };

    const confirmAndSendEmail = async () => {
        const { to, cc, subject, body } = emailPreviewData;

        try {
            const res = await fetch(`${process.env.REACT_APP_API_URL}/email/Send-meeting-recap`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem("token")}`
                },
                body: JSON.stringify({
                    to,
                    cc,
                    subject,
                    body,
                    text: plainTextVersion(body)
                })
            });

            const result = await res.json();
            if (res.ok) {
                appAlert("✅ Email successfully sent.");
                setEmailPreviewOpen(false);
            } else {
                appAlert("❌ Failed to send email: " + (result.error || "Unknown error"));
            }
        } catch (err) {
            console.error(err);
            appAlert("❌ Error sending email.");
        }
    };

    const goToPartyDetail = () => {
        if (!selectedCustomer?.id) return;
        if (selectedCustomer.type === "Customer") {
            navigate(`/customer/create-customer/details?id=${selectedCustomer.id}`);
        } else if (selectedCustomer.type === "GlobalAgent") {
            navigate(`/global-agent/create-global-agent/details?id=${selectedCustomer.id}`);
        } else if (selectedCustomer.type === "ServiceProvider") {
            navigate(`/service-provider/create-service-provider/details?id=${selectedCustomer.id}`);
        }
    };

    return (
        <DashboardLayout>
            <DashboardNavbar />
            <MDBox pt={3}>
                {/* Başarı mesajı: ref, kayıttan sonra mesaja kaydırmak için kullanılır */}
                <div ref={successMessageRef}>
                    {successMessage && <CrmNotice sx={{ mb: 2 }}>{successMessage}</CrmNotice>}
                </div>
                <CrmPageHeader
                    title={isEditing ? "Edit Schedule Meeting Details" : "Add Schedule Meeting Details"}
                    subtitle="This information will give you more information about the Meeting Card."
                />
                {readOnlyMode && (
                    <ReadOnlyBanner
                        message="This meeting is in read-only view. Click Edit to make changes."
                        onEdit={() => setReadOnlyMode(false)}
                    />
                )}
            </MDBox>
            <ReadOnlyFieldset readOnly={readOnlyMode}>
            <MDBox
                    sx={{
                ...crmCardSx,
                overflow: "visible",
                p: 3,
            }}>
                <MDBox mt={3}>
                    <MDTypography variant="h6">
                        {partyType === "Customer"
                            ? "CUSTOMER INFORMATION"
                            : partyType === "GlobalAgent"
                                ? "GLOBAL AGENT INFORMATION"
                                : "SERVICE PROVIDER INFORMATION"}
                    </MDTypography>

                    {selectedCustomer && (
                        <MDTypography
                            variant="caption"
                            onClick={goToPartyDetail}
                            sx={{
                                // Stays clickable while the form is read-only: it only opens the party card.
                                pointerEvents: "auto",
                                cursor: "pointer",
                                color: "#1976d2",
                                fontWeight: 600,
                                textDecoration: "underline",
                                mt: 0.5,
                                display: "inline-block"
                            }}
                        >
                            {selectedCustomer.name}
                        </MDTypography>
                    )}
                </MDBox>


                <MDBox mt={3}>
                    <Grid container spacing={2} alignItems="flex-end">

                        {/* TYPE BUTTONS */}
                        <Grid item xs={12} sm={2}>
                            <ToggleButtonGroup
                                color="primary"
                                value={partyType}
                                exclusive
                                onChange={(_, val) => val && setPartyType(val)}
                                size="small"
                                fullWidth
                                sx={{
                                    ".MuiToggleButtonGroup-grouped": {
                                        flex: 1,
                                        borderColor: "#ddd !important",
                                        "&.Mui-selected": { bgcolor: "#e6f0ff" },
                                    },
                                    ".MuiToggleButton-root": {
                                        textTransform: "none",
                                        fontWeight: 600,
                                        height: 55,
                                    },
                                }}
                            >
                                <ToggleButton value="Customer">Customer</ToggleButton>
                                <ToggleButton value="GlobalAgent">Global Agent</ToggleButton>
                                <ToggleButton value="ServiceProvider">Service Provider</ToggleButton>
                            </ToggleButtonGroup>
                        </Grid>
                        {/* CUSTOMER SEARCH */}
                        <Grid item xs={12} sm={3}>
                            <Autocomplete
                                value={selectedCustomer || null}
                                onChange={handleCustomerChange}
                                inputValue={inputValue}
                                onInputChange={(e, v) => { setInputValue(v); setOpen(v.length > 0); }}
                                options={customerOptions}
                                getOptionLabel={(o) => o?.name || ""}
                                filterOptions={(opts, state) =>
                                    opts.filter((o) =>
                                        o.name.toLowerCase().includes(state.inputValue.toLowerCase())
                                    )
                                }
                                open={isEditing ? false : open}
                                onClose={() => setOpen(false)}
                                disabled={isEditing}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label={
                                        partyType === "Customer" ? "Search Customer" : partyType === "GlobalAgent" ? "Search Global Agent" : "Search Service Provider"}
                                        variant="outlined"
                                        size="small"
                                        InputProps={{
                                            ...params.InputProps,
                                        }}
                                        sx={{
                                            "& .MuiInputBase-root": {
                                                height: 40,        // 🟩 Autocomplete KUTUSU TAM HİZALI
                                                paddingRight: "32px !important",
                                            }
                                        }}
                                    />
                                )}
                            />
                        </Grid>

                        {/* TAX ID */}
                        <Grid item xs={12} sm={1}>
                            <TextField
                                label="Tax ID"
                                value={taxId || ""}
                                onChange={(e) => setTaxId(e.target.value)}
                                disabled={isEditing}
                                fullWidth
                                variant="outlined"
                                size="small"
                                InputLabelProps={{ shrink: true }}
                                sx={{
                                    "& .MuiInputBase-root": { height: 40 },   // 🟩 SAME HEIGHT
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} sm={3}>
                            <Autocomplete
                                fullWidth
                                options={countryOptions}
                                getOptionLabel={(o) => o.label}
                                value={customerCountry ? { label: customerCountry } : null}
                                onChange={(e, n) => setCustomerCountry(n ? n.label : "")}
                                disabled={isEditing}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        variant="outlined"
                                        size="small"
                                        InputLabelProps={{ shrink: true }}
                                        label={t("Country")}
                                        sx={{ "& .MuiInputBase-root": { height: 56 } }}
                                    />
                                )}
                            />
                        </Grid>
                        {/* CITY */}
                        <Grid item xs={12} sm={3}>
                            <Autocomplete
                                fullWidth
                                options={cityOptions}
                                loading={cityLoading}
                                value={city || null}
                                onChange={(e, v) => setCity(v || "")}
                                freeSolo
                                onInputChange={(e, v) => setCity(v || "")}
                                disabled={isEditing}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="City"
                                        variant="outlined"
                                        size="small"
                                        InputLabelProps={{ shrink: true }}
                                        sx={{
                                            "& .MuiInputBase-root": { height: 45 },
                                        }}
                                    />
                                )}
                            />
                        </Grid>


                    </Grid>

                    <Grid container spacing={2} mt={3} alignItems="flex-end">

                        {/* Representative Name */}
                        <Grid item xs={12} sm={3}>
                            <TextField
                                label="Representatives Name"
                                value={representatives || ""}
                                onChange={(e) => setRepresentatives(e.target.value)}
                                disabled={isEditing}
                                fullWidth
                                variant="outlined"
                                size="small"
                                InputLabelProps={{ shrink: true }}
                                sx={{
                                    "& .MuiInputBase-root": {
                                        height: 40,       // 🔥 Yükseklik eşitlendi
                                        padding: "0 8px", // 🔥 İç padding fix
                                    }
                                }}
                            />
                        </Grid>

                        {/* Representative Title */}
                        <Grid item xs={12} sm={3}>
                            <TextField
                                label="Representatives Title"
                                value={representativesTitle || ""}
                                onChange={(e) => setRepresentativesTitle(e.target.value)}
                                disabled={isEditing}
                                fullWidth
                                variant="outlined"
                                size="small"
                                InputLabelProps={{ shrink: true }}
                                sx={{
                                    "& .MuiInputBase-root": {
                                        height: 40,
                                        padding: "0 8px",
                                    }
                                }}
                            />
                        </Grid>

                        {/* Contact Info */}
                        <Grid item xs={12} sm={6}>
                            <TextField
                                label="Contact Info"
                                value={representativesContact || ""}
                                onChange={(e) => setRepresentativesContact(e.target.value)}
                                disabled={isEditing}
                                fullWidth
                                variant="outlined"
                                size="small"
                                InputLabelProps={{ shrink: true }}
                                sx={{
                                    "& .MuiInputBase-root": {
                                        height: 40,
                                        padding: "0 8px",
                                    }
                                }}
                            />
                        </Grid>

                    </Grid>

                    <br />
                    <Grid container spacing={3} alignItems="flex-end">

                        {/* Web Site */}
                        <Grid item xs={12} sm={3}>
                            <TextField
                                type="text"
                                label="Web Site"
                                value={webSite}
                                disabled={isEditing}
                                onChange={(e) => setWebSite(e.target.value)}
                                fullWidth
                                InputLabelProps={{ shrink: true }}
                                sx={{
                                    "& .MuiInputBase-root": { height: 40, padding: "0 8px" }}}
                            />
                        </Grid>

                        {/* Industry */}
                        <Grid item xs={12} sm={3}>
                            <TextField
                                type="text"
                                label="Industry"
                                value={industry}
                                disabled={isEditing}
                                onChange={(e) => setIndustry(e.target.value)}
                                fullWidth
                                InputLabelProps={{ shrink: true }}
                                sx={{
                                    "& .MuiInputBase-root": { height: 40, padding: "0 8px" }}}
                            />
                        </Grid>

                        {/* Company Size */}
                        <Grid item xs={12} sm={3}>
                            <Autocomplete
                                options={companySizeOptions}
                                value={companySize || null}
                                onChange={(_, newValue) => setCompanySize(newValue)}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Company Size"
                                        fullWidth
                                        InputLabelProps={{ shrink: true }}
                                        sx={{
                                            "& .MuiInputBase-root": { height: 40, padding: "0 8px" }
                                        }}
                                    />
                                )}
                            />
                        </Grid>

                        {/* Logistics Decision Authority */}
                        <Grid item xs={12} sm={3}>
                            <Autocomplete
                                options={logisticsOptions}
                                value={logisticsDecision || null}
                                onChange={(_, newValue) => setLogisticsDecision(newValue)}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Logistics Decision Authority"
                                        fullWidth
                                        InputLabelProps={{ shrink: true }}
                                        sx={{
                                            "& .MuiInputBase-root": { height: 40, padding: "0 8px" }
                                        }}
                                    />
                                )}
                            />
                        </Grid>

                    </Grid>

                    <br />

                    <MDBox mt={3}>
                        <MDTypography variant="h6">PRE-MEETING NOTES</MDTypography>
                    </MDBox>
                    <br />

                    <Grid container spacing={3} alignItems="flex-start">

                        {/* Pre-Meeting Title */}
                        <Grid item xs={12} sm={6}>
                            <TextField
                                label="Pre-Meeting Title"
                                fullWidth
                                value={preMeetingTitle}
                                onChange={(e) => setPreMeetingTitle(e.target.value)}
                                InputLabelProps={{ shrink: true }}
                                sx={{
                                    "& .MuiInputBase-root": { height: 40, padding: "0 8px" }
                                }}
                            />
                        </Grid>

                        {/* Pre-Meeting Notes */}
                        <Grid item xs={12} sm={6}>
                            <TextField
                                label="Pre-Meeting Notes"
                                fullWidth
                                value={preMeetingNotes}
                                onChange={(e) => setPreMeetingNotes(e.target.value)}
                                multiline
                                minRows={5}
                                InputLabelProps={{ shrink: true }}
                                sx={{
                                    "& .MuiInputBase-root": { padding: "8px" },
                                    "& textarea": { fontSize: 14 }
                                }}
                            />
                        </Grid>
                    </Grid>

                    <br />

                    <LocalizationProvider dateAdapter={AdapterDateFns} locale={tr}>
                        <Grid container spacing={3} alignItems="flex-start">

                            {/* Meeting Title */}
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    label="Meeting Title"
                                    fullWidth
                                    value={meetingTitle}
                                    onChange={(e) => setMeetingTitle(e.target.value)}
                                    InputLabelProps={{ shrink: true }}
                                    sx={{
                                        "& .MuiInputBase-root": { height: 40, padding: "0 8px" }
                                    }}
                                />
                            </Grid>

                            {/* Meeting Date */}
                            <Grid item xs={12} sm={3}>
                                <DatePicker
                                    label="Meeting Date"
                                    value={meetingDate}
                                    onChange={(newDate) => {
                                        setMeetingDate(newDate);
                                        if (!newDate) setDateError("Meeting Date is required");
                                        else setDateError("");
                                    }}
                                    format="dd/MM/yyyy"
                                    slotProps={{
                                        textField: {
                                            size: "small",
                                            sx: {
                                                "& .MuiInputBase-root": { height: 40 },
                                            },
                                            error: Boolean(dateError),
                                            helperText: dateError || ""
                                        }
                                    }}
                                />
                            </Grid>

                            {/* Meeting Time */}
                            <Grid item xs={12} sm={1}>
                                <TextField
                                    label="Time"
                                    type="time"
                                    value={meetingTime}
                                    onChange={(e) => {
                                        const v = e.target.value;
                                        setMeetingTime(v);
                                        if (!v) setTimeError("Time is required");
                                        else setTimeError("");
                                    }}
                                    InputLabelProps={{ shrink: true }}
                                    inputProps={{ step: 900 }}
                                    error={Boolean(timeError)}
                                    helperText={timeError || ""}
                                    fullWidth
                                    sx={{
                                        "& .MuiInputBase-root": { height: 40, padding: "0 10px" },
                                    }}
                                />
                            </Grid>

                        </Grid>
                    </LocalizationProvider>

                    <br />


                    <Grid container spacing={2} alignItems="center">

                        {/* Meeting Duration */}
                        <Grid item xs={12} sm={2}>
                            <Autocomplete
                                options={meetingDurations}
                                value={meetingDuration || null}
                                onChange={(event, newValue) => setMeetingDuration(newValue)}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Meeting Duration"
                                        fullWidth
                                        InputLabelProps={{ shrink: true }}
                                        sx={{
                                            "& .MuiInputBase-root": { height: 40 },
                                            "& .MuiOutlinedInput-input": { padding: "0 10px !important" }
                                        }}
                                    />
                                )}
                            />
                        </Grid>

                        {/* Meeting Type */}
                        <Grid item xs={12} sm={2}>
                            <Autocomplete
                                options={meetingTypes}
                                value={meetingType || null}
                                onChange={(event, newValue) => setMeetingType(newValue)}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Meeting Type"
                                        fullWidth
                                        InputLabelProps={{ shrink: true }}
                                        sx={{
                                            "& .MuiInputBase-root": { height: 40 },
                                            "& .MuiOutlinedInput-input": { padding: "0 10px !important" }
                                        }}
                                    />
                                )}
                            />
                        </Grid>

                        {/* Meeting Platform */}
                        <Grid item xs={12} sm={2}>
                            <Autocomplete
                                options={meetingPlatforms}
                                value={meetingPlatform || null}
                                onChange={(event, newValue) => setMeetingPlatform(newValue)}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Meeting Platform"
                                        fullWidth
                                        InputLabelProps={{ shrink: true }}
                                        sx={{
                                            "& .MuiInputBase-root": { height: 40 },
                                            "& .MuiOutlinedInput-input": { padding: "0 10px !important" }
                                        }}
                                    />
                                )}
                            />
                        </Grid>

                        {/* Sales Reps */}
                        <Grid item xs={12} sm={3}>
                            <Autocomplete
                                multiple
                                options={salesRepOptions}
                                getOptionLabel={(option) => option.label}
                                value={salesRep}
                                onChange={(event, newValues) => setSalesRep(newValues)}
                                isOptionEqualToValue={(option, value) => option.id === value.id}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Sales Representatives"
                                        InputLabelProps={{ shrink: true }}
                                        sx={{
                                            "& .MuiOutlinedInput-input": { padding: "0 10px !important" }
                                        }}
                                    />
                                )}
                            />
                        </Grid>

                        {/* Meeting Status */}
                        <Grid item xs={12} sm={3} display="flex" alignItems="center">
                            <FormControlLabel
                                control={
                                    <Switch
                                        checked={meetingStatus === "Completed"}
                                        onChange={(e) => {
                                            const newStatus = e.target.checked ? "Completed" : "Planned";
                                            setMeetingStatus(validateMeetingStatus(newStatus));
                                        }}
                                        sx={{
                                            "& .MuiSwitch-thumb": {
                                                backgroundColor:
                                                    meetingStatus === "Completed" ? "orange" : "gray"
                                            },
                                            "& .MuiSwitch-track": {
                                                backgroundColor:
                                                    meetingStatus === "Completed" ? "lightgreen" : "#ccc"
                                            }
                                        }}
                                        disabled={wasCompleted}
                                    />
                                }
                                label={`Meeting Status: ${meetingStatus}`}
                                sx={{ ml: 1, fontSize: "14px" }}
                            />
                        </Grid>

                    </Grid>
                    <br />

                    <Grid container spacing={2} alignItems="flex-start">

                        {/* Participants */}
                        <Grid item xs={12} sm={6}>
                            <MDTypography variant="caption" sx={{ mb: 1, display: "block" }}>
                                Participants
                            </MDTypography>

                            {(participants && participants.length > 0 ? participants : [""]).map((participant, index) => (
                                <Grid container spacing={1} key={index} alignItems="center">

                                    {/* Participant Name Input */}
                                    <Grid item xs={9}>
                                        <TextField
                                            fullWidth
                                            value={participant}
                                            onChange={(e) => handleParticipantChange(index, e.target.value)}
                                            InputLabelProps={{ shrink: true }}
                                            sx={{
                                                "& .MuiInputBase-root": { height: 40 }
                                            }}
                                        />
                                    </Grid>

                                    {/* Action Buttons */}
                                    <Grid item xs={3} display="flex" alignItems="center" gap={1}>
                                        {index > 0 && (
                                            <RemoveRowButton onClick={() => handleRemoveParticipant(index)} tooltip="Remove participant" />
                                        )}

                                        {index === participants.length - 1 && (
                                            <AddRowButton onClick={handleAddParticipant} tooltip="Add participant" />
                                        )}
                                    </Grid>

                                </Grid>
                            ))}
                        </Grid>

                        {/* Attendees */}
                        <Grid item xs={12} sm={6}>
                            <MDTypography variant="caption" sx={{ mb: 1, display: "block" }}>
                                Attendees
                            </MDTypography>

                            <Autocomplete
                                multiple
                                options={salesRepOptions}
                                getOptionLabel={(option) => option.label}
                                value={attendees}
                                onChange={(event, newValues) => setAttendees(newValues)}
                                isOptionEqualToValue={(option, value) => option.id === value.id}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        InputLabelProps={{ shrink: true }}
                                    />
                                )}
                            />
                        </Grid>

                    </Grid>



                    <MDBox mt={3}>
                        <MDTypography variant="h6">POST MEETING NOTES</MDTypography>
                    </MDBox>
                    <br />

                    <Grid item xs={12}>
                        <TextField
                            label="Meeting Notes"
                            multiline
                            fullWidth
                            variant="outlined"
                            minRows={4}
                            value={meetingNotes}
                            onChange={(e) => setMeetingNotes(e.target.value)}
                            disabled={wasCompleted || meetingStatus !== "Completed"}
                            InputLabelProps={{ shrink: true }}
                            sx={{
                                "& .MuiInputBase-root": {
                                    padding: "10px 12px",
                                }
                            }}
                            error={meetingStatus === "Completed" && meetingNotes.length < 25}
                            helperText={
                                wasCompleted
                                    ? "This meeting was previously marked as Completed. Notes cannot be changed."
                                    : meetingStatus === "Completed" && meetingNotes.length < 25
                                        ? `⚠️ Please enter at least ${25 - meetingNotes.length} more characters.`
                                        : ""
                            }
                        />
                    </Grid>

                    <MDBox mt={3}>
                        <MDTypography variant="h6">RE-CAP MEETING</MDTypography>
                    </MDBox>

                    <Grid container spacing={1} mt={0}>
                        <Grid item xs={12} sm={4}>
                            <TextField
                                label="Re-cap Meeting Notes"
                                fullWidth
                                variant="outlined"
                                multiline
                                minRows={5}
                                value={recapMeetingNotes}
                                onChange={(e) => setRecapMeetingNotes(e.target.value)}
                                disabled={!isEditing && meetingStatus !== "Completed"}
                                InputLabelProps={{ shrink: true }}
                                sx={{
                                    "& .MuiInputBase-root": {
                                        padding: "10px 12px",
                                    }
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} sm={2}>
                            <FormControlLabel
                                control={
                                    <Switch
                                        checked={Boolean(recapCompleted)}
                                        onChange={handleRecapSwitch}
                                        disabled={!isEditing && meetingStatus !== "Completed"}
                                        color="primary"
                                    />
                                }
                                label={recapCompleted ? "Completed" : "Not Completed"}
                            />
                        </Grid>

                        <Grid item xs={12} sm={2}>
                            <Button
                                variant="contained"
                                onClick={handleSendPreview}
                                disabled={!recapCompleted}
                                sx={{
                                    backgroundColor: recapCompleted ? "#0B1F3A" : "#E4E7EC",
                                    color: recapCompleted ? "#FFFFFF !important" : "#667085 !important",
                                    boxShadow: "none",
                                    borderRadius: "8px",
                                    textTransform: "none",
                                    fontWeight: 600,
                                    "&:hover": { backgroundColor: recapCompleted ? "#12345B" : "#E4E7EC", boxShadow: "none" },
                                }}
                            >
                                Send to Customer
                            </Button>
                        </Grid>

                        <Grid item xs={12} sm={2}>
                            <Button
                                variant="contained"
                                onClick={() => {
                                    navigate("/create-opportunity", {
                                        state: {
                                            meetingDate,
                                            customer: selectedCustomer?.name || "",
                                            fromMeetings: true
                                        }
                                    });
                                }}
                                sx={{
                                    backgroundColor: recapCompleted ? "#0B1F3A" : "#E4E7EC",
                                    color: recapCompleted ? "#FFFFFF !important" : "#667085 !important",
                                    boxShadow: "none",
                                    borderRadius: "8px",
                                    textTransform: "none",
                                    fontWeight: 600,
                                    "&:hover": { backgroundColor: recapCompleted ? "#12345B" : "#E4E7EC", boxShadow: "none" },
                                }}
                            >
                                Create Opportunities
                            </Button>
                        </Grid>
                        <Grid item xs={12} sm={2}>
                            <Button
                                variant="contained"
                                onClick={() => {
                                    navigate("/sales-lead/create-sales-lead/details", {
                                        state: {
                                            fromVisitPlan: true,

                                            // ✅ Company
                                            leadCompany: selectedCustomer?.name || "",
                                            selectedCustomer,
                                            taxId: taxId || "",
                                            customerCountry: customerCountry || "",
                                            city: city || "",
                                            representatives: representatives || "",
                                            representativesTitle: representativesTitle || "",
                                            representativesContact: representativesContact || "",
                                            webSite: webSite || "",
                                            industry: industry || "",
                                            companySize: companySize || "",
                                            logisticsDecision: logisticsDecision || "",
                                            salesRep: salesRep || [],
                                            attendees: attendees || [],
                                        },
                                    });
                                }}
                                sx={{
                                    backgroundColor: recapCompleted ? "#0B1F3A" : "#E4E7EC",
                                    color: recapCompleted ? "#FFFFFF !important" : "#667085 !important",
                                    boxShadow: "none",
                                    borderRadius: "8px",
                                    textTransform: "none",
                                    fontWeight: 600,
                                    "&:hover": { backgroundColor: recapCompleted ? "#12345B" : "#E4E7EC", boxShadow: "none" },
                                }}
                            >
                                Create Sales Lead
                            </Button>

                        </Grid>
                    </Grid>
                </MDBox>{" "}
                <br />
                <br />

                <Dialog open={emailPreviewOpen} onClose={() => setEmailPreviewOpen(false)} maxWidth="md" fullWidth>
                    <DialogTitle>Email Draft Preview</DialogTitle>

                    <DialogContent dividers>
                        <div style={{ marginBottom: 16 }}>
                            <strong>To:</strong>
                            <div
                                contentEditable
                                suppressContentEditableWarning
                                onBlur={(e) => setEmailPreviewData((prev) => ({ ...prev, to: e.target.innerText.trim() }))}
                                style={{
                                    border: "1px solid #ccc",
                                    padding: "8px",
                                    minHeight: "30px",
                                    borderRadius: "4px",
                                    marginTop: "4px"
                                }}
                            >
                                {emailPreviewData.to}
                            </div>
                        </div>

                        <div style={{ marginBottom: 16 }}>
                            <strong>CC:</strong>
                            <div
                                contentEditable
                                suppressContentEditableWarning
                                onBlur={(e) => setEmailPreviewData((prev) => ({ ...prev, cc: e.target.innerText.trim() }))}
                                style={{
                                    border: "1px solid #ccc",
                                    padding: "8px",
                                    minHeight: "30px",
                                    borderRadius: "4px",
                                    marginTop: "4px"
                                }}
                            >
                                {emailPreviewData.cc}
                            </div>
                        </div>

                        <div style={{ marginBottom: 16 }}>
                            <strong>Subject:</strong>
                            <div
                                contentEditable
                                suppressContentEditableWarning
                                onBlur={(e) =>
                                    setEmailPreviewData((prev) => ({ ...prev, subject: e.target.innerText.trim() }))
                                }
                                style={{
                                    border: "1px solid #ccc",
                                    padding: "8px",
                                    minHeight: "30px",
                                    borderRadius: "4px",
                                    marginTop: "4px"
                                }}
                            >
                                {emailPreviewData.subject}
                            </div>
                        </div>

                        <div style={{ marginBottom: 16 }}>
                            <strong>Body:</strong>
                            <div
                                contentEditable
                                suppressContentEditableWarning
                                onBlur={(e) => setEmailPreviewData((prev) => ({ ...prev, body: e.target.innerHTML }))}
                                dangerouslySetInnerHTML={{ __html: emailPreviewData.body }}
                                style={{
                                    border: "1px solid #ccc",
                                    padding: "16px",
                                    minHeight: "300px",
                                    borderRadius: "4px",
                                    backgroundColor: "#f9f9f9",
                                    fontFamily: "'Segoe UI', sans-serif",
                                    fontSize: "15px",
                                    lineHeight: "1.6",
                                    color: "#333",
                                    marginTop: "4px"
                                }}
                            />
                        </div>
                    </DialogContent>

                    <DialogActions>
                        <CrmActionButton variant="secondary" onClick={() => setEmailPreviewOpen(false)}>
                            Cancel
                        </CrmActionButton>
                        <CrmActionButton onClick={confirmAndSendEmail}>Approve and Send</CrmActionButton>
                    </DialogActions>
                </Dialog>

                {/* Form ve Buton */}
                <form onSubmit={submitHandler}>
                    <CrmActionButton onClick={submitHandler}>
                        {isEditing ? "Update Meeting" : "Create Meeting"}
                    </CrmActionButton>
                </form>
            </MDBox>
            </ReadOnlyFieldset>
            <MDBox mb={3} />
            <Footer />
        </DashboardLayout>
    );
};

export default CreateMeeting;
